import React, {useState} from 'react';
import ModalHeader from '../presentations/ModalHeader';
import Repository, {UpdateDepartmentRepositoryInterface} from '../services/repository';
import {useForm} from 'react-hook-form';
import ModalFooter from '../presentations/ModalFooter';
import Button from '../presentations/Button';
import Spinner2 from '../presentations/Spinner2';
import ModalBody from '../presentations/ModalBody';
import {ApiError, ApiResponse} from '../services/api';
import Padding from '../presentations/Padding';
import AlertApiErrorMessage from '../presentations/AlertApiErrorMessage';
import {DepartmentType} from '../stores/departments';
import DepartmentManagerFormFieldset from '../presentations/DepartmentManagerFormFieldset';

interface DepartmentUpdaterInterface {
  department: DepartmentType
  onClose: () => void
}

const DepartmentUpdater: React.FC<DepartmentUpdaterInterface> = (props) => {
  const repository                       = new Repository();
  const [sending, setSending]            = useState<boolean>(false);
  const [alertMessage, setAlertMessage]  = useState<React.ReactElement | null>(null);
  const {register, handleSubmit, errors} = useForm<UpdateDepartmentRepositoryInterface>({
    defaultValues: {
      title: props.department.title,
    }
  });

  const onSubmit = (post: UpdateDepartmentRepositoryInterface) => {
    setSending(true);

    post.memberLimit = 100;

    console.log(post);

    repository.updateDepartment(props.department.id, post)
            .then(() => {
              props.onClose();
            })
            .catch(({response}: ApiError) => {
              console.log(response);
              setSending(false);
              setAlertMessage(<AlertApiErrorMessage response={response} title={<p>更新に失敗しました。</p>}/>);

            });
  }

  return (
          <form noValidate method={'post'} onSubmit={handleSubmit(onSubmit)}>
            <ModalHeader><h3>部署を編集</h3></ModalHeader>
            <ModalBody>
              <Padding padding={'30px 40px 40px'}>
                <>
                  {alertMessage}
                  <DepartmentManagerFormFieldset register={register} errors={errors}/>
                </>
              </Padding>
            </ModalBody>
            <ModalFooter>
              <Button type={'button'} width={'130px'} margin={'0 10px 0 0'} fontSize={12} onClick={props.onClose}>
                キャンセル
              </Button>
              <Button type={'submit'} color={'secondary'} width={'130px'} fontSize={12} disabled={sending}>
                {sending ? <Spinner2/> : null} 更新
              </Button>
            </ModalFooter>
          </form>
  );
}

export default DepartmentUpdater;
